var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-aside',[_c('SideMenu',{attrs:{"items":_vm.items}})],1),_c('el-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }